module.exports = "/build/web/svg/dropdown-minus.f87bb779159ad48cf44fc3e3ba479e59.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/dropdown-minus.svg
// module id = 105
// module chunks = 24